import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconNews: React.FC<IconProps> = ({ width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.8386 6.47409C14.6673 6.13665 14.2183 6.06133 13.9462 6.32435L9.2767 10.8383L12.5245 17.2327L18.9412 16.1667C19.3161 16.1044 19.5226 15.6959 19.3505 15.3571L14.8386 6.47409ZM13.0587 18.2843L19.1256 17.2765C20.2503 17.0896 20.8699 15.8642 20.3536 14.8476L15.8417 5.96461C15.3276 4.95234 13.9806 4.72641 13.1643 5.51552L8.25689 10.2594L4.91293 11.9579C4.08199 12.3799 3.75052 13.3957 4.17257 14.2266L6.80378 19.407C7.22583 20.238 8.24159 20.5694 9.07252 20.1474L9.77918 19.7885L11.2613 22.7064C11.6833 23.5373 12.6991 23.8688 13.53 23.4467L13.7351 23.3425C14.5661 22.9205 14.8975 21.9047 14.4755 21.0738L13.0587 18.2843ZM11.9904 18.6653L10.7822 19.279L12.2643 22.1969C12.405 22.4739 12.7436 22.5844 13.0205 22.4437L13.2257 22.3395C13.5027 22.1988 13.6132 21.8602 13.4725 21.5832L11.9904 18.6653ZM11.481 17.6623L8.34025 11.4789L5.42239 12.961C5.14541 13.1016 5.03492 13.4402 5.17561 13.7172L7.80683 18.8976C7.94752 19.1746 8.28608 19.285 8.56306 19.1443L11.481 17.6623Z"
                fill="black"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.5157 3.68304C20.7334 3.90469 20.7302 4.26084 20.5085 4.4785L18.0631 6.87986C17.8414 7.09749 17.4853 7.09428 17.2676 6.8726C17.05 6.65092 17.0532 6.2948 17.2748 6.07714L19.7203 3.6758C19.9419 3.45814 20.2981 3.46138 20.5157 3.68304Z"
                fill="black"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.3938 6.94634C23.5443 7.21814 23.446 7.56043 23.1742 7.71095L19.4835 9.75462C19.2117 9.90509 18.8695 9.80677 18.7189 9.53502C18.5685 9.26323 18.6668 8.92094 18.9385 8.77042L22.6293 6.72674C22.901 6.57628 23.2433 6.6746 23.3938 6.94634Z"
                fill="black"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.0574 11.0668C25.1263 11.3697 24.9365 11.6711 24.6336 11.74L20.8768 12.5942C20.5739 12.6631 20.2724 12.4734 20.2036 12.1705C20.1347 11.8675 20.3244 11.5661 20.6274 11.4972L24.3841 10.643C24.6871 10.5741 24.9885 10.7639 25.0574 11.0668Z"
                fill="black"
            />
        </svg>
    );
};

export default IconNews;
